import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from './IELTSCourse';
import { skimmingScanningData, getDataForDifficulty } from './data/skills/reading/skimmingScanning';

export default function SkimmingScanning() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : skimmingScanningData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
